import { type SelectOption } from '../../../../../components';
import {
  PROFESSIONAL_QUALIFICATION_PROFESSIONAL_FIELD,
  PROFESSIONAL_QUALIFICATION_PROFESSIONAL_QUALIFICATION,
  PROFESSIONAL_QUALIFICATION_AWARD_BODY,
} from '../constants';
import { PAGE_TEXT } from '../lang';

const {
  OTHER_INFORMATION: { PROFESSIONAL_QUALIFICATION },
} = PAGE_TEXT;

const ProfessionalFieldText =
  PROFESSIONAL_QUALIFICATION.OPTIONS_LABEL
    .PROFESSIONAL_QUALIFICATION_PROFESSIONAL_FIELD;
const ProfessionalFieldKeys: string[] = Object.keys(ProfessionalFieldText);
export const professionalFieldOptions: SelectOption[] = Object.values(
  ProfessionalFieldText,
).map((label: string, index: number) => ({
  value:
    PROFESSIONAL_QUALIFICATION_PROFESSIONAL_FIELD[
      ProfessionalFieldKeys[
        index
      ] as keyof typeof PROFESSIONAL_QUALIFICATION_PROFESSIONAL_FIELD
    ],
  label,
}));

const ProfessionalQualificationText =
  PROFESSIONAL_QUALIFICATION.OPTIONS_LABEL
    .PROFESSIONAL_QUALIFICATION_PROFESSIONAL_QUALIFICATION;
const ProfessionalQualificationKeys: string[] = Object.keys(
  ProfessionalQualificationText,
);
export const professionalQualificationOptions: SelectOption[] = Object.values(
  ProfessionalQualificationText,
).map((label: string, index: number) => ({
  value:
    PROFESSIONAL_QUALIFICATION_PROFESSIONAL_QUALIFICATION[
      ProfessionalQualificationKeys[
        index
      ] as keyof typeof PROFESSIONAL_QUALIFICATION_PROFESSIONAL_QUALIFICATION
    ],
  label,
}));

const awardBodyText =
  PROFESSIONAL_QUALIFICATION.OPTIONS_LABEL
    .PROFESSIONAL_QUALIFICATION_AWARD_BODY;
const awardBodyKeys: string[] = Object.keys(awardBodyText);
export const awardBodyOptions: SelectOption[] = Object.values(
  awardBodyText,
).map((label: string, index: number) => ({
  value:
    PROFESSIONAL_QUALIFICATION_AWARD_BODY[
      awardBodyKeys[index] as keyof typeof PROFESSIONAL_QUALIFICATION_AWARD_BODY
    ],
  label,
}));
